export class EmployeeByDuty {
  public employeeId: string | undefined = undefined;
  public fullName: string | undefined = undefined;
  public fiscalCode: string | undefined = undefined;
  public testTypes: string[] = [];
}
